import angular, { IOnInit, IPromise, IQService, IScope } from "angular";
import {
  ProcessApiResponse,
  ProcessInstancesNotesView,
  ProcessState,
} from "../../../model/ProcessApi";
import { IFieldArray } from "AngularFormly";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import {
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../records/forms/formView";
import { Record } from "../../../../records/server/crud";
import { IQuery, ServiceResponse } from "../../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { ProcessInformation } from "../../../model/ProcessGroups";

export class ProcessNotesComponentController implements IOnInit {
  adding: boolean = false;
  noteFields: IFieldArray = [];
  noteModel: any = undefined;
  notes!: ProcessInstancesNotesView[];
  noteQuery: IQuery = {};
  noteUsers: any[] = [];
  states: ProcessState[] = [];

  /*bindings*/
  process!: ProcessApiResponse<any>;
  processInformation!: ProcessInformation;
  /*end bindings*/

  static $inject = [FormViewServiceName, ServerUtilityName, "$q"];
  constructor(
    private readonly formViewService: FormViewService,
    private readonly serverUtility: ServerUtility,
    private readonly $q: IQService
  ) {}

  addNote() {
    this.adding = true;
    const process = this.process;
    this.noteModel = {
      StateId: process.States.find((s) => s.Name === process.Status)?.Id,
    };
  }

  submit(formViewController: FormViewController) {
    return this.formViewService
      .submitForm<ServiceResponse<ProcessInstancesNotesView>>({
        formObject: this.noteModel,
        formViewController,
        method: "POST",
        url: `/api/processes/instances/${this.process.Id}/notes`,
      })
      .then(() => this.getFilteredNotes())
      .then((r) => {
        this.adding = false;
        this.notes = r;
        return r;
      });
  }

  getStateName(stateId: string) {
    const state = this.process.States.find((s) => s.Id === stateId);
    return state?.Name;
  }

  static fetchNotes(
    serverUtility: ServerUtility,
    processId: number,
    query: IQuery
  ): IPromise<ProcessInstancesNotesView[]> {
    return serverUtility.fetchAll<ProcessInstancesNotesView>({
      url: `api/processes/instances/${processId}/notes`,
      query,
    });
  }

  $onInit(): void {
    const states = (this.states = this.getProcessStates());

    this.initializeFormFields(states);
    this.fetchNoteUsers().then((users) => (this.noteUsers = users));

    this.noteQuery = {
      OrderBy: "-Id",
      CreatedById: undefined,
      NoteContains: undefined,
    };

    this.getFilteredNotes();
  }

  private fetchNoteUsers() {
    return this.serverUtility
      .fetchAll<any>({
        url: `/api/processes/instances/${this.process.Id}/notes/users`,
        query: {
          OrderBy: "FirstName,LastName",
        },
      })
      .then((users) => {
        users.forEach((u) => (u.normalized = u.DisplayName.toLowerCase()));

        return users;
      });
  }

  getFilteredNotes() {
    return ProcessNotesComponentController.fetchNotes(
      this.serverUtility,
      this.process.Id,
      this.noteQuery
    ).then((notes) => (this.notes = notes));
  }

  queryNoteUsers(search: string) {
    if (!search || search === "") {
      return this.$q.when(this.noteUsers);
    }

    const normalizedSearch = search.toLowerCase();
    return this.$q.when(
      this.noteUsers.filter((u) => u.normalized.includes(normalizedSearch))
    );
  }

  initializeFormFields(states: ProcessState[]) {
    this.noteFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.selectField({
            key: "StateId",
            required: true,
            options: states.map((s) => ({
              value: s.Id,
              name: s.Name,
            })),
          }),
        ],
        4
      ),
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleStringField({
            key: "Notes",
            label: "Note",
            required: true,
          }),
        ],
        1
      ),
    ];
  }

  getProcessStates() {
    return this.process.States.filter((s) =>
      ["InProgress", "Complete"].includes(s.StatusCategory)
    );
  }
}
